/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	FormlyFieldConfig
} from '@ngx-formly/core';
import {
	FormlyConstants
} from '@shared/constants/formly.constants';

/**
 * A constant library used to defined commonly used formly fields.
 *
 * @export
 * @class CommonFormlyFieldConstants
 */
export class CommonFormlyFieldConstants
{
	/**
	 * Gets the common public field config.
	 *
	 * @type {FormlyFieldConfig}
	 * @memberof CommonFormlyFieldConstants
	 */
	public static readonly publicField: FormlyFieldConfig =
		<FormlyFieldConfig>
		{
			key: 'public',
			type: FormlyConstants.customControls.customInputSwitch,
			wrappers: [
				FormlyConstants.customControls.customFieldWrapper
			],
			props: {
				label: 'Public',
				tooltip: 'If Public is enabled, then that means'
					+ ' the item is public and accessible to'
					+ ' users. If Public is'
					+ ' disabled, then only the Owner\'s will'
					+ ' be able to interact with this item.',
				default: true
			}
		};

	/**
	 * Gets the common public field config.
	 *
	 * @type {FormlyFieldConfig}
	 * @memberof CommonFormlyFieldConstants
	 */
	public static readonly ownershipSecurityGroupField: FormlyFieldConfig =
		<FormlyFieldConfig>
		{
			key: 'ownershipSecurityGroupId',
			type: FormlyConstants.customControls.customSelect,
			wrappers: [
				FormlyConstants.customControls.customFieldWrapper
			],
			props: {
				label: 'Item Owner(s)',
				tooltip: 'Set Additional Owner\'s'
					+ ' that will be allowed to edit'
					+ ' the item.',
				placeholder: 'Select an ownership group',
				showClear: true,
				required: true
			}
		};
}